export const optionTypeMember = [
  {
    label: "個人",
    value: "indivisual",
    name: "business_structure"
  },
  {
    label: "会社・団体",
    value: "organization",
    name: "business_structure"
  },
];
export const optionMemberOfTimeUsed = [
  {
    label: "初回",
    value: "初回",
    name: "used_times"
  },
  {
    label: "2～5回目",
    value: "2～5回目",
    name: "used_times"
  },
  {
    label: "6～10回目",
    value: "6～10回目",
    name: "used_times"
  },
  {
    label: "11回以上",
    value: "11回以上",
    name: "used_times"
  },
];
export const optionGender = [
  {
    label: "男",
    value: "male",
    name: "gender"
  },
  {
    label: " 女",
    value: "female",
    name: "gender"
  },
  {
    label: "その他",
    value: "other",
    name: "gender"
  },
  {
    label: "回答しない ",
    value: "noanswer",
    name: "gender"
  },
];
export const optionAddress = [
  {
    label: "北海道",
    value: "北海道",
  },
  {
    label: "青森県",
    value: "青森県",
  },
  {
    label: "岩手県",
    value: "岩手県",
  },
  {
    label: "宮城県",
    value: "宮城県",
  },
  {
    label: "秋田県",
    value: "秋田県",
  },
  {
    label: "山形県",
    value: "山形県",
  },
  {
    label: "福島県",
    value: "福島県",
  },
  {
    label: "茨城県",
    value: "茨城県",
  },
  {
    label: "栃木県",
    value: "栃木県",
  },
  {
    label: "群馬県",
    value: "群馬県",
  },
  {
    label: "埼玉県",
    value: "埼玉県",
  },
  {
    label: "千葉県",
    value: "千葉県",
  },
  {
    label: "東京都",
    value: "東京都",
  },
  {
    label: "神奈川県",
    value: "神奈川県",
  },
  {
    label: "新潟県",
    value: "新潟県",
  },
  {
    label: "富山県",
    value: "富山県",
  },
  {
    label: "石川県",
    value: "石川県",
  },
  {
    label: "福井県",
    value: "福井県",
  },
  {
    label: "山梨県",
    value: "山梨県",
  },
  {
    label: "長野県",
    value: "長野県",
  },
  {
    label: "岐阜県",
    value: "岐阜県",
  },
  {
    label: "静岡県",
    value: "静岡県",
  },
  {
    label: "愛知県",
    value: "愛知県",
  },
  {
    label: "三重県",
    value: "三重県",
  },
  {
    label: "滋賀県",
    value: "滋賀県",
  },
  {
    label: "京都府",
    value: "京都府",
  },
  {
    label: "大阪府",
    value: "大阪府",
  },
  {
    label: "兵庫県",
    value: "兵庫県",
  },
  {
    label: "奈良県",
    value: "奈良県",
  },
  {
    label: "和歌山県",
    value: "和歌山県",
  },
  {
    label: "鳥取県",
    value: "鳥取県",
  },
  {
    label: "島根県",
    value: "島根県",
  },
  {
    label: "岡山県",
    value: "岡山県",
  },
  {
    label: "広島県",
    value: "広島県",
  },
  {
    label: "山口県",
    value: "山口県",
  },
  {
    label: "徳島県",
    value: "徳島県",
  },
  {
    label: "香川県",
    value: "香川県",
  },
  {
    label: "愛媛県",
    value: "愛媛県",
  },
  {
    label: "高知県",
    value: "高知県",
  },
  {
    label: "福岡県",
    value: "福岡県",
  },
  {
    label: "佐賀県",
    value: "佐賀県",
  },
  {
    label: "長崎県",
    value: "長崎県",
  },
  {
    label: "熊本県",
    value: "熊本県",
  },
  {
    label: "大分県",
    value: "大分県",
  },
  {
    label: "宮崎県",
    value: "宮崎県",
  },
  {
    label: "鹿児島県",
    value: "鹿児島県",
  },
  {
    label: "沖縄県",
    value: "沖縄県",
  },
];
export const optionTypeContent = [
  {
    label: "本予約希望",
    value: "本予約希望",
  },
  {
    label: " 仮予約希望",
    value: "仮予約希望",
  },
  {
    label: "見学予約希望",
    value: "見学予約希望",
  },
  {
    label: "質問等 ",
    value: "質問等",
  },
  {
    label: "飲食プラン",
    value: "飲食プラン",
  },
];


export const dataContentOfInquiry = [
  {
      label: '本予約希望',
      value: '本予約希望',
      name: 'content'
  },
  {
      label: '仮予約希望',
      value: '仮予約希望',
      name: 'content'
  },
  {
      label: '内見希望',
      value: '内見希望',
      name: 'content'
  },
  {
      label: '質問',
      value: '質問',
      name: 'content'
  },
  {
      label: 'ケータリング相談',
      value: 'ケータリング相談',
      name: 'content'
  },
  {
      label: 'その他',
      value: 'その他',
      name: 'content'
  }
];

export const dataContentOfInquiryTwo = [
  {
    label: '本予約希望',
    value: '本予約希望',
    name: 'content'
  },
  {
    label: '仮予約希望',
    value: '仮予約希望',
    name: 'content'
  },
  {
    label: '質問',
    value: '質問',
    name: 'content'
  }
];


export const optionConfirmAge = [
  {
    label: "20歳以上",
    value: "20歳以上",
  },
  {
    label: " 18歳以上〜20歳未満",
    value: "18歳以上〜20歳未満",
  },
];
export const dayOfWeek = ["日", "月", "火", "水", "木", "金", "土"];
export const optionPurposeUser = [
  {
    id: 1,
    label: "一つを選んでください",
    value: "",
  },
  {
    id: 2,
    label: " パーティー",
    value: "パーティー",
  },
  {
    id: 3,
    label: " 撮影 ",
    value: "撮影  ",
  },
  {
    id: 4,
    label: " 会議室",
    value: "会議室",
  },
  {
    id: 5,
    label: " 民泊",
    value: "民泊",
  },
  {
    id: 6,
    label: " ウェディング",
    value: "ウェディング",
  },
  {
    id: 7,
    label: " イベント",
    value: "イベント",
  },
  {
    id: 8,
    label: " 展示",
    value: "展示",
  },
  {
    id: 9,
    label: " 物販",
    value: "物販",
  },
  {
    id: 10,
    label: " シェア",
    value: "シェア",
  },
  {
    id: 11,
    label: " 広告",
    value: "広告",
  },
  {
    id: 12,
    label: " 菜園",
    value: "菜園",
  },
  {
    id: 13,
    label: " ママ会",
    value: "ママ会",
  },
  {
    id: 14,
    label: " その他",
    value: "その他",
  },
  {
    id: 15,
    label: " カルチャー",
    value: "カルチャー",
  },
];

export const INTERNET = {
  INTERNET_ENV_INSTALL_STATUS: 1,
  INTERNET_ENV_WIRED: 2,
  INTERNET_ENV_WIRELESS: 3,
  INTERNET_ENV_ADDITIONAL_TEXT: 4,
};
export const EATING = {
  EATING_AND_DRINKING_POSSIBLE: 1,
  EATING_AND_DRINKING_ACOHOLIC: 2,
  EATING_AND_DRINKING_GARBAGE_DISPOSAL: 3,
  EATING_AND_DRINKING_ADDITIONAL_TEXT: 4,
};
export const GARBAGE = {
  GARBAGE_COLLECTION_TYPE: 1,
  GARBAGE_COLLECTION_PRICE: 2,
  GARBAGE_COLLECTION_CLASSIFICATION: 3,
  GARBAGE_COLLECTION_ADDITIONAL_TEXT: 4,
};
export const RESTROOM = {
  RESTROOM_PLACE: 1,
  RESTROOM_TYPE: 2,
  RESTROOM_QUANTITY: 3,
  RESTROOM_ADDITIONAL_TEXT: 4,
};
export const AIR_CONDITIONER = {
  AIR_CONDITIONER_KINDS: 1,
  AIR_CONDITIONER_OPERATION: 2,
  AIR_CONDITIONER_ADDITIONAL_TEXT: 3,
};
export const POWER_SUPPLY = {
  POWER_SUPPLY_AVAIL: 1,
  POWER_SUPPLY_QUANTITY: 2,
  POWER_SUPPLY_CAPACITY: 3,
  POWER_SUPPLY_ADDITIONAL_TEXT: 4,
};
export const PAYMENT_METHOD = {
  CREDIT_CARD: "credit-card",
  BANK_TRANSFER: "bank-transfer",
  CASH_ON_SITE: "cash-on-site",
  iNTERNAL_OTHERWISE_HANDLED: "internal-otherwise-handled",
  CHOOSE_LATER_BY_CUSTOMER: "choose-later-by-customer",
  NO_PAYMENT_REQUIRED: "no-payment-required",
  PAID: "paid",
  OTHER: "other",
  RECEIPT: "receipt",
};

export const PLAN_TYPE = {
  RESERVATION_REQUEST: "reservation-request",
  INSTANT_RESERVATION: "instant-reservation",
  MULTIPLE_TYPE: "multiple-type",
};

export const PAYMENT_METHOD_LABEL = {
  'credit-card': 'クレジットカード',
  'bank-transfer': '銀行振込',
  'cash-on-site': '当日現金払い',
  'internal-otherwise-handled': '内部その他の処理',
  'choose-later-by-customer': '後で選択',
  'no-payment-required': 'お支払不要',
  'paid': "paid",
  'other': 'その他',
  'receipt': '請求書払い'
}; 
